module.exports = __webpack_public_path__ + "static/media/rowrowlite_background.1108783f.jpg";